import { gql } from "@apollo/client";
export const WORKSHEET_FIELDS = gql`
  fragment CustomFields on Custom {
    name
    internalName
    scope
    scopeFormat
    quantity
    unit
    rate
    pricing {
      version
      mode
      value
      discount
    }
    calculationVersion
    sourceProductId
    sourceProductRevision
    helpers {
      hoursPerDay
      production {
        enabled
        source
        materialRowId
        quantity
        unit
        rate
        period
      }
      travel {
        enabled
        roundTripHours
        visits
      }
    }
    pricingMethod
    pricingOverrideField
    markup
    overheadPercentage
    indirectPercentage
    fixedPrice
    profitAmount
    pricingBaseline {
      pricing {
        version
        mode
        value
        discount
      }
      pricingMethod
      markup
      fixedPrice
      profitAmount
    }
    areaSource
    area
    areaUnit
    rows {
      rowId
      quantitySource
      hauling {
        materialRowId
        allocationPercent
        capacity
        capacityUnit
        roundTripHours
        loadHours
        unloadHours
        planningHours
        maxTripsPerDay
        quantityMode
        haulQuantity
        haulUnit
        planningEnabled
        fullLoads
      }
      sourcePlantId
      sourcePlantName
      sourceType
      sourceId
      sourceName
      name
      category
      jobSize
      jobSizeUnit
      hoursPerTruck
      truckingUnit
      trucksNeeded
      truckCapacity
      truckRateHours
      truckRateTons
      truckRateYards
      truckRateLoads

      quantity
      unit
      rate
      calculation
      factor
      factorAreaUnit
      factorLabel
      thickness
      quantityOverride
    }
  }
`;
export const SETTINGS = gql`
  query CustomSettings {
    customSettings {
      workingHoursPerDay
      enabled
      markup
      canManageProducts
      canManageSettings
      factors {
        label
        value
      }
    }
  }
`;
export const PRODUCTS = gql`
  query CustomProducts {
    customProducts {
      revision
      organizationProductType {
        id
        name
      }
      id
      definition {
        ...CustomFields
      }
    }
  }
  ${WORKSHEET_FIELDS}
`;
export const PROPOSAL = gql`
  query CustomProposal($id: ID!) {
    customProposal(id: $id) {
      id
      customFinancials {
        sendErrors
        incomplete
        productsWithoutCosts
        profit
        netMargin
      }
      stages {
        id
        proposalProducts {
          id
          ordering
          isOptional
          discount
          overallTotalAfterDiscount
          custom {
            ...CustomFields
          }
        }
      }
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
        }
      }
    }
  }
  ${WORKSHEET_FIELDS}
`;
export const SAVE_PRODUCT = gql`
  mutation SaveCustomProduct($id: ID, $productTypeId: ID!, $input: CustomInput!) {
    saveCustomProduct(id: $id, productTypeId: $productTypeId, input: $input) {
      id
      organizationProductType {
        id
        name
      }
      definition {
        ...CustomFields
      }
    }
  }
  ${WORKSHEET_FIELDS}
`;
export const ARCHIVE_PRODUCT = gql`
  mutation ArchiveCustomProduct($id: ID!) {
    archiveCustomProduct(id: $id)
  }
`;
export const SAVE_ITEM = gql`
  mutation SaveCustomItem($id: ID, $stageId: ID!, $input: CustomInput!, $discount: String) {
    saveCustomItem(id: $id, stageId: $stageId, input: $input, discount: $discount) {
      id
    }
  }
`;

export const PRODUCT_TYPES = gql`
  query CustomProductTypes {
    getOrganizationProductTypes {
      id
      name
    }
  }
`;

export const UPDATE_LIBRARY_PRODUCT = gql`
  mutation UpdateCustomLibraryProduct($id: ID!, $expectedRevision: String!, $input: CustomInput!) {
    updateCustomLibraryProduct(id: $id, expectedRevision: $expectedRevision, input: $input) {
      id
      revision
      definition {
        ...CustomFields
      }
    }
  }
  ${WORKSHEET_FIELDS}
`;
